// src/pages/404/index.ts

// @jsx createElement
// @jsxFrag createFragment
import {
  createElement,
  createFragment,
  showFullscreenMessage,
} from "@mitosis/frontend-base";

document.addEventListener("DOMContentLoaded", async () => {
  try {
    showFullscreenMessage(
      <>
        <h1>Strona nie znaleziona</h1>
        <a href="/" class="link">
          Wróć do strony głównej
        </a>
      </>,
    );
  } catch (error) {
    console.error("Failed to initialize page:", error);
  }
});
